export const myColors = {
    primaryOrange: "#F67939",
    lightOrange: "#FFAB76",
    thirdOrange: "#FFE4DA",
    bgPrimary: "#FFFFFF",
    bgInput: "#F7F8F9",
    primaryBlack: "#090808",
    secondaryBlack: "#2E2E2E",
    thirdBlack: "#000",
    fourthBlack: "#1F1F39",
    fifthBlack: "#0D0D0D",
    primaryPink: "#FFB6C1",
    primaryGray: "gray",
    secondaryGray: "#3B3B3B",
    thirdGray: "#585757",
    primaryShadow: "#000000",
    primaryNavy: "#172B4D",
  };

  export const color ={
    primaryTextBlue:'rgb(6, 44, 119)',
      secondaryBlue:'#0677F9'
}